import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { alpha, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import { SearchIcon2 } from "../../Icon";

/**
 * Punto de entrada al buscador en el navbar. No busca ni despliega resultados:
 * al hacer click lleva a /search, donde vive el buscador completo. En esa ruta
 * se oculta para no duplicar el input.
 */
export const SearchEntry = () => {
  const [t] = useTranslation("report");
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (location.pathname.startsWith("/search")) return null;

  return (
    <Paper
      role="button"
      tabIndex={0}
      aria-label={t("searchBar.search_in_casemanager")}
      onClick={() => navigate("/search")}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          navigate("/search");
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: isMobile ? "40vw" : "18vw",
        height: 40,
        px: 1.5,
        borderRadius: 6,
        cursor: "pointer",
        border: `1px solid ${theme.palette.blueGray200.main}`,
        boxShadow: `0 0 3px -3px ${alpha(theme.palette.common.black, 0.8)}`,
        transition: "box-shadow 0.3s ease-in-out",
        "&:hover, &:focus-visible": {
          boxShadow: `0 0 6px -2px ${alpha(theme.palette.common.black, 0.8)}`,
        },
      }}
    >
      <SearchIcon2 size={18} color={theme.palette.blueGray500.main} />
      <Typography variant="body2" color="text.secondary" noWrap>
        {`${t("searchBar.search")}...`}
      </Typography>
    </Paper>
  );
};
